<canvas baseChart height="150"
  [type]="'line'"
  [data]="lineChartData"
  [options]="lineChartOptions"
  [legend]="lineChartLegend">
</canvas>
